import { Modal } from "@4uhub/lib4uhub";
import {
  Box,
  Button,
  Link,
  Skeleton,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";

interface ILoginHeaderTextProps {
  text: string;
}

const translationPath = "page.loginTemporary.";

export const LoginHeaderText = ({ text }: ILoginHeaderTextProps) => {
  const { t } = useTranslation();

  const navigate = useNavigate();

  const theme = useTheme();

  const [openModal, setOpenModal] = useState(false);

  const handleOpenModal = () => {
    setOpenModal(true);
  };

  const handleCloseModal = () => {
    setOpenModal(false);
  };

  const handleRedirectLogin = () => {
    navigate("/login");
  };

  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const maxTextLenght = 60;

  const displayedText =
    text.length > maxTextLenght
      ? `${text.substring(0, maxTextLenght)}...`
      : text;

  return (
    <>
      <Box sx={{ minHeight: "65px", width: "100%" }}>
        {!text && (
          <Skeleton
            variant="rectangular"
            sx={(t) => ({
              width: "100%",
              height: "100%",
              borderRadius: t.shape.borderRadius,
            })}
          />
        )}
        {text && (
          <Box
            sx={{
              bgcolor: "#FFF4E5",
              p: 1.5,
              display: "flex",
              alignItems: "center",
              gap: 1,
              borderBottom: "1px solid #bbdefb",
            }}
          >
            <HelpOutlineIcon sx={{ color: "", fontSize: 20 }} />
            <Typography variant="caption" color="text.secondary">
              {displayedText}{" "}
              <Link
                component="button"
                variant="caption"
                onClick={handleOpenModal}
              >
                {t(translationPath + "see_more")}
              </Link>
            </Typography>
          </Box>
        )}
      </Box>

      <Modal
        open={openModal}
        onClose={handleCloseModal}
        title={t(translationPath + "modal_title") || "Informations"}
      >
        <Box
          sx={{
            pt: 1,
          }}
        >
          <Typography
            variant="body1"
            sx={{
              mb: 3,
              color: "text.secondary",
              lineHeight: 1.6,
              whiteSpace: "pre-wrap",
            }}
          >
            {text}
          </Typography>

          <Box sx={{ display: "flex", justifyContent: "flex-end", gap: 1 }}>
            <Button
              onClick={handleCloseModal}
              color="inherit"
              sx={{ fontSize: isMobile ? 12 : 14 }}
            >
              {t(translationPath + "close")}
            </Button>
            <Button
              onClick={handleRedirectLogin}
              variant="contained"
              disableElevation
              sx={{ fontSize: isMobile ? 12 : 14 }}
            >
              {t(translationPath + "go_to_main_login")}
            </Button>
          </Box>
        </Box>
      </Modal>
    </>
  );
};
